import { useEffect, useState } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Btn, P, H4 } from '../../AbstractElements';
import { Password, ResetPassword as ResetPasswordText, ConfirmPassword, changePassword } from '../../Constant';
import { resetPassword, verifyResetCode } from '../../firebase/utils';
import Loader from '../../Layout/Loader';
import BtnLoader from '../../Common/Component/Loader';

const ResetPassword = ({ oobCode, emailParam, parentLoading }) => {
    const [loadings, setLoadings] = useState({
        resetPassword: false,
        verify: true
    });
    const [passwords, setPasswords] = useState({
        password: '',
        confirmPassword: ''
    });
    const [togglePasswords, setTogglePasswords] = useState({
        password: false,
        confirmPassword: false
    });
    const navigate = useNavigate();

    const resetPasswordHandler = async () => {
        const { password, confirmPassword } = passwords;
        if (!password) return toast.error("Password is required");
        if (!confirmPassword) return toast.error("Confirm Password is required");
        if (password !== confirmPassword) return toast.error('Passwords do not match');

        setLoadings({ ...loadings, resetPassword: true });
        try {
            await resetPassword(oobCode, confirmPassword);
            toast.success('Password reset successfully');
            navigate('/login');
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoadings({ ...loadings, resetPassword: false });
        }
    };

    useEffect(() => {
        const verifyCode = async () => {
            setLoadings({ ...loadings, verify: true });
            try {
                await verifyResetCode(oobCode, emailParam);
            } catch (error) {
                toast.error(error.message);
                return navigate('/login');
            }
            setLoadings({ ...loadings, verify: false });
        }
        verifyCode();
    }, []);

    if (loadings.verify || parentLoading) return <Loader />;

    return (
        <Form className='theme-form'>
            <H4>{ResetPasswordText}</H4>
            <P>{'Enter your password to reset'}</P>
            <FormGroup className='position-relative'>
                <Label className='col-form-label'>{Password}</Label>
                <div className='position-relative'>
                    <Input className='form-control' type={togglePasswords.password ? 'text' : 'password'} onChange={(e) => setPasswords({ ...passwords, password: e.target.value })} value={passwords.password} />
                    <div className='show-hide' onClick={() => setTogglePasswords({ ...togglePasswords, password: !togglePasswords.password })}><span className={togglePasswords.password ? '' : 'show'}></span></div>
                </div>
            </FormGroup>
            <FormGroup className='position-relative'>
                <Label className='col-form-label'>{ConfirmPassword}</Label>
                <div className='position-relative'>
                    <Input className='form-control' type={togglePasswords.confirmPassword ? 'text' : 'password'} onChange={(e) => setPasswords({ ...passwords, confirmPassword: e.target.value })} value={passwords.confirmPassword} />
                    <div className='show-hide' onClick={() => setTogglePasswords({ ...togglePasswords, confirmPassword: !togglePasswords.confirmPassword })}><span className={togglePasswords.confirmPassword ? '' : 'show'}></span></div>
                </div>
            </FormGroup>
            <div className='m-t-40'>
                <Btn attrBtn={{ color: 'primary', disabled: loadings.resetPassword, className: 'd-block w-100 mt-2', onClick: resetPasswordHandler }}>{loadings.resetPassword ? <BtnLoader /> : changePassword}</Btn>
            </div>
        </Form>
    )
}

export default ResetPassword;